/* eslint-disable no-underscore-dangle */
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import actions from '../actions';
import {
    dataFrom,
    dataTrigger,
    Icon,
    React,
    S,
    showNotification,
    View
} from '../common';
import { SCHEME } from '../scheme';
import {
    adaptClinicToFav,
    adaptDoctorToFav
} from '../screens/App/snippets/utils';
import {
    getFavoritesFull,
    getIsPersonalized
} from '../selectors';
import { putIntoStore } from '../store';

export const FavIcon = React.memo(
    dataTrigger(
        getIsPersonalized,
        dataFrom(getFavoritesFull)(({
            item = {},
            data,
            type,
        }) => {
            const onPress = useCallback(() => {
                const adaptedItem = type === 'physicians' ? adaptDoctorToFav(item) : adaptClinicToFav(item);
                const op = data?.some((e) => e.id === item?.id || e?.id === item?._id) ? 'remove' : 'add';
                const message = `titles.${op}${type}Bookmark`;
                const localizedMessage = Object.R(message);
                actions.toggleFullFavorites(adaptedItem);
                setTimeout(() => {
                    showNotification(localizedMessage, false);
                }, 0);
            }, [ item,
                data ]);
            const name = `bookmark-${
                data?.some((e) => e.id === item?.id || e?.id === item?._id) ? 'active' : 'normal'
            }`;
            return (
                <View styles={S.absoluteTopRight}>
                    <Icon
                        name={name}
                        color="white"
                        onPress={onPress}
                    />
                </View>
            );
        }),
    ),
);

export const FavoritesIcon = ({
    color,
    cb,
    isActive,
}) => {
    const isPersonalized = useSelector(getIsPersonalized);
    return isPersonalized ? (
        <Icon
            name={`bookmark-${isActive ? 'active' : 'normal'}`}
            color={color}
            onPress={() => {
                putIntoStore(SCHEME.PHYSICIANS_FILTER_FAVORITES, !isActive);
                actions.updateDocFilters({ filterFavoriteDoctors: !isActive });
                cb && cb();
            }}
        />
    ) : null;
};
